import { CxpAssetsFormComponent } from './cxp-assets-form/cxp-assets-form.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavRoute } from 'src/app/utils/menu';
import {Entities, Pages, PeriodState, Permission} from '@Interfaces/index';
import {AccesoriosComponent} from '@pages/movimiento-bienes/accesorios/accesorios.component';
import { FormAssetsComponent } from './form-assets/form-assets.component';
import { MasterAssetsComponent } from './master-assets/master-assets.component';
import { ConsumptionReportComponent } from './consumption-report/consumption-report.component';
import { AssignResponsibleComponent } from './assign-responsible/assign-responsible.component';


export const MovimientoBienesRoutes: NavRoute[] = [
  {
    path: Pages.MOVEMENT_CONTROL,
    nav: { title: 'Control de propiedad, planta y equipo ', icon: 'remove' }, // menu-temp
    redirectTo: '/nav/home'
  }, {
    path: Pages.MOVEMENT_ACCESSORIES,
    nav: { title: 'Accesorios ', icon: 'mouse' },
    component: AccesoriosComponent
  },
  {
    path: Pages.MASTER_ASSETS+'/:type/:id',
    component: MasterAssetsComponent
  }, 
  {
    path: Pages.MOVEMENT_ASSETS_FORM_ADD+'/:id',
    component: FormAssetsComponent
  },
  {
    path: Pages.CXP_ASSETS_FORM+'/:id',
    component: CxpAssetsFormComponent,
    entity: Entities.PAYMENT_ORDER_WP,
    permission: 'addCXPAssets',
    periodSate: PeriodState.OPEN
  },
  {
    path: Pages.LIST_MOVEMENT_ASSETS,
    nav: { title: 'Asignar Responsable', icon: 'swap_vert' },
    component: AssignResponsibleComponent,
    entity: Entities.ACTIVO_FIJO,
    permission: 'generateMovements',
    periodSate: PeriodState.OPEN
  },
  {
    path: Pages.CONSUMPTION_REPORT,
    component: ConsumptionReportComponent,
    entity: Entities.ACTIVO_FIJO,
    permission: Permission.LIST
  }
];

@NgModule({
  imports: [RouterModule.forChild(MovimientoBienesRoutes)],
  exports: [RouterModule]
})
export class MovimientoBienesRoutingModule { }
